var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "employee-department" }, [
    _c(
      "div",
      { staticClass: "select-input" },
      [
        _vm._t("tabs"),
        _vm._v(" "),
        _c(
          "el-tabs",
          {
            on: { "tab-click": _vm.tabClick },
            model: {
              value: _vm.activeTabName,
              callback: function ($$v) {
                _vm.activeTabName = $$v
              },
              expression: "activeTabName",
            },
          },
          [
            !_vm.closeUser
              ? _c(
                  "el-tab-pane",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.userLoading,
                        expression: "userLoading",
                      },
                    ],
                    attrs: { label: "员工", name: "user" },
                  },
                  [
                    _c("el-input", {
                      staticClass: "search-input",
                      attrs: {
                        placeholder: "搜索员工",
                        size: "small",
                        "prefix-icon": "el-icon-search",
                      },
                      on: { input: _vm.userSearchChange },
                      model: {
                        value: _vm.searchUserInput,
                        callback: function ($$v) {
                          _vm.searchUserInput = $$v
                        },
                        expression: "searchUserInput",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "search-list" },
                      [
                        _c(
                          "el-checkbox",
                          {
                            staticClass: "all-check",
                            attrs: {
                              indeterminate: _vm.isIndeterminate,
                              disabled: _vm.radio,
                            },
                            on: { change: _vm.handleCheckAllChange },
                            model: {
                              value: _vm.checkAll,
                              callback: function ($$v) {
                                _vm.checkAll = $$v
                              },
                              expression: "checkAll",
                            },
                          },
                          [_vm._v("全选")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "checkout-boxs" },
                          _vm._l(_vm.userList, function (user, index) {
                            return !user.hidden
                              ? _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass: "colleagues-list",
                                  },
                                  [
                                    _c(
                                      "el-checkbox",
                                      {
                                        on: {
                                          change: function ($event) {
                                            return _vm.userCheckboxChange(
                                              user,
                                              index
                                            )
                                          },
                                        },
                                        model: {
                                          value: user.isCheck,
                                          callback: function ($$v) {
                                            _vm.$set(user, "isCheck", $$v)
                                          },
                                          expression: "user.isCheck",
                                        },
                                      },
                                      [
                                        _c("xr-avatar", {
                                          staticClass: "search-img",
                                          attrs: {
                                            name: user.realname,
                                            size: 24,
                                            src: user.img,
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(user.realname)),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e()
                          }),
                          0
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.closeDep
              ? _c(
                  "el-tab-pane",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.depLoading,
                        expression: "depLoading",
                      },
                    ],
                    attrs: { label: "部门", name: "dep" },
                  },
                  [
                    _c("el-input", {
                      staticClass: "search-input",
                      staticStyle: { "margin-bottom": "10px" },
                      attrs: {
                        placeholder: "搜索部门",
                        size: "small",
                        "prefix-icon": "el-icon-search",
                      },
                      on: { input: _vm.depSearchChange },
                      model: {
                        value: _vm.searchDepInput,
                        callback: function ($$v) {
                          _vm.searchDepInput = $$v
                        },
                        expression: "searchDepInput",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "search-list" },
                      [
                        _c(
                          "el-breadcrumb",
                          {
                            attrs: { "separator-class": "el-icon-arrow-right" },
                          },
                          _vm._l(_vm.breadcrumbList, function (item, index) {
                            return _c("el-breadcrumb-item", { key: index }, [
                              _c(
                                "a",
                                {
                                  attrs: { href: "javascript:;" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.breadcrumbBtn(item, index)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(item.label))]
                              ),
                            ])
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "checkout-boxs" },
                          _vm._l(_vm.depShowList, function (depItem, index) {
                            return !depItem.hidden
                              ? _c(
                                  "div",
                                  { key: index, staticClass: "checkout-box" },
                                  [
                                    _c("el-checkbox", {
                                      on: {
                                        change: function ($event) {
                                          return _vm.depCheckboxChange(
                                            depItem,
                                            index
                                          )
                                        },
                                      },
                                      model: {
                                        value: depItem.isCheck,
                                        callback: function ($$v) {
                                          _vm.$set(depItem, "isCheck", $$v)
                                        },
                                        expression: "depItem.isCheck",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.enterDepChildren(depItem)
                                          },
                                        },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(depItem.name)),
                                        ]),
                                        _vm._v(" "),
                                        depItem.children
                                          ? _c("span", {
                                              staticClass:
                                                "el-icon-arrow-right",
                                            })
                                          : _vm._e(),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e()
                          }),
                          0
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ],
      2
    ),
    _vm._v(" "),
    !_vm.radio || _vm.showPreview
      ? _c("div", { staticClass: "checked-content" }, [
          _c(
            "div",
            { staticClass: "checked-top" },
            [
              _c("span", { staticClass: "select-info" }, [
                _vm._v("已选择"),
                _c("span", { staticClass: "select-info--num" }, [
                  _vm._v(_vm._s(_vm.userSelectCount + _vm.depSelectCount)),
                ]),
                _vm._v("项"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "text" }, on: { click: _vm.clearAll } },
                [_vm._v("清空")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "select-content" },
            [
              _c(
                "flexbox",
                { attrs: { justify: "stretch", wrap: "wrap" } },
                _vm._l(_vm.checkedUserDepList, function (item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "select-item text-one-line" },
                    [
                      _vm._v(_vm._s(item.realname || item.name)),
                      _c("i", {
                        staticClass: "el-icon-close delete-icon",
                        on: {
                          click: function ($event) {
                            return _vm.selectDelete(item, index)
                          },
                        },
                      }),
                    ]
                  )
                }),
                0
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }